import { extendTheme } from '@chakra-ui/react';

import { getNestedValue } from './getNestedValue';

import type { PaymentElementThemeType } from '../@types';
import type {
  StripeCardNumberElementOptions,
  StripeCardCvcElementOptions,
  StripeCardExpiryElementOptions,
} from '@stripe/stripe-js';

type DefaultCssType = Record<string, any>;

const transformCss = (
  el: any,
  colors: DefaultCssType,
  sizes: DefaultCssType,
) => {
  const colorValue = getNestedValue(colors, el, null);
  const sizeValue = getNestedValue(sizes, el, null);
  return colorValue || sizeValue || el;
};

const prepareStripeCss = (
  chakraStyle: DefaultCssType,
  colors: DefaultCssType,
  sizes: DefaultCssType,
) =>
  Object.keys(chakraStyle).reduce((acc: DefaultCssType, el: string) => {
    const node = chakraStyle[el];
    /** @TODO Quickfix, improve. */
    let key = el.startsWith('_') ? el.replace('_', ':') : el;
    key = key === ':placeholder' ? '::placeholder' : key;
    acc[key] =
      typeof node === 'object' && node !== null
        ? prepareStripeCss(node, colors, sizes)
        : transformCss(chakraStyle[el], colors, sizes);
    return acc;
  }, {});

export const generateStripeTheme = (components: any, foundations: any) => {
  const base = prepareStripeCss(
    components.Input.baseStyle.field,
    foundations.colors,
    foundations.fontSizes,
  );
  const invalidColor = transformCss(
    // eslint-disable-next-line no-underscore-dangle
    components.FormLabel.baseStyle._invalid.color,
    foundations.colors,
    foundations.fontSizes,
  );
  const baseInput = {
    style: {
      base,
      invalid: {
        iconColor: invalidColor,
        color: invalidColor,
      },
    },
  };
  const cardInput: StripeCardNumberElementOptions = {
    showIcon: true,
    iconStyle: 'default',
    ...baseInput,
  };
  const cvcInput: StripeCardCvcElementOptions = {
    ...baseInput,
  };
  const expiryInput: StripeCardExpiryElementOptions = {
    ...baseInput,
  };

  return {
    cardInput,
    cvcInput,
    expiryInput,
  };
};

export const generateMainTheme = (theme: PaymentElementThemeType) => {
  const {
    globalStyles: global,
    colorMode: initialColorMode,
    foundations,
    components,
  } = theme;

  const themeDefinitions = {
    styles: {
      global,
    },
    config: {
      initialColorMode,
      useSystemColorMode: false,
    },
    ...foundations,
    components: {
      ...components,
    },
  };

  return extendTheme(themeDefinitions);
};
